// Redux
import { Dispatch } from "redux";

// Classes
import {
  GPA,
  EntryTerm,
  TestScores,
  ProspectProfileReducerState,
  Term
} from "../classes/prospectProfile.classes";
import { Range } from "../../classes/filter.classes";

// Action Creators
import {
  setIntendedLevelOfStudy,
  setEntryTerm,
  setIntendedMajor,
  setGPA,
  setTestScores,
  setProspectProfileState
} from "../actionCreators/prospectProfile.actionCreators";

export const setIntendedLevelOfStudyValue = (
  dispatch: Dispatch<any>,
  value: "Any" | "Undergraduate" | "Graduate"
) => {
  dispatch(setIntendedLevelOfStudy(value));
};

export const setEntryTermValue = (
  dispatch: Dispatch<any>,
  entryTerm: EntryTerm,
  value: any,
  identifier: "selectionProspectProfileEntryTerm" | "value",
  startYear: number,
  endYear: number
) => {
  // Use onChange event given from the component to construct a
  // DateRegistered and pass it to Redux.
  let newEntryTerm: EntryTerm;

  if (identifier === "selectionProspectProfileEntryTerm") {
    newEntryTerm = {
      ...entryTerm,
      selection: value
    };
    if (entryTerm.selection !== value) {
      switch (value) {
        case "Any":
          newEntryTerm.value = undefined;
          break;
        case "Term-Year":
          // Intitialize the value for whatever the initial value of the dropdown
          // should be (I do not currently know it)
          newEntryTerm.value = [];
          break;
        case "Term":
          // Intitialize the value for whatever the initial value of the dropdown
          // should be (I do not currently know it)
          newEntryTerm.value = new Term();
          break;
        case "Year":
          // Intitialize the value for whatever the initial value of the dropdown
          // should be (I do not currently know it)
          newEntryTerm.value = new Range(startYear, endYear);
          break;
      }
    }
  } else {
    newEntryTerm = {
      ...entryTerm,
      value: value
    };
  }
  dispatch(setEntryTerm(newEntryTerm));
};

export const setIntendedMajorValue = (
  dispatch: Dispatch<any>,
  value: any[]
) => {
  dispatch(setIntendedMajor(value));
};

export const setGPAValue = (
  dispatch: Dispatch<any>,
  gpa: GPA,
  value: any,
  identifier: "selectionProspectProfileGPA" | "value"
) => {
  let newGPA: GPA;

  if (identifier === "selectionProspectProfileGPA") {
    newGPA = {
      ...gpa,
      selection: value
    };
    if (gpa.selection !== value) {
      newGPA.value = new Range(0, 4.0);
    }
  } else {
    newGPA = {
      ...gpa,
      value: value
    };
  }
  dispatch(setGPA(newGPA));
};

export const setTestScoresValue = (
  dispatch: Dispatch<any>,
  testScores: TestScores,
  value: any,
  identifier: "selectionProspectProfileTestScores" | "value"
) => {
  let newTestScores: TestScores;

  if (identifier === "selectionProspectProfileTestScores") {
    newTestScores = {
      ...testScores,
      selection: value
    };
    if (testScores.selection !== value) {
      switch (value) {
        case "Any":
          newTestScores.value.sat = new Range(400, 1600);
          newTestScores.value.act = new Range(1, 36);
          break;
        case "SAT":
          newTestScores.value.act = new Range(1, 36);
          break;
        case "ACT":
          newTestScores.value.sat = new Range(400, 1600);
          break;
      }
    }
  } else {
    newTestScores = {
      ...testScores,
      value: {
        ...testScores.value,
        ...value
      }
    };
  }
  dispatch(setTestScores(newTestScores));
};

export const initializeProspectProfileState = (
  dispatch: Dispatch<any>,
  state: ProspectProfileReducerState
) => {
  dispatch(setProspectProfileState(state));
};
